import type {
  PaymentCreateInput,
  PaymentDto,
  PaymentPatchInput,
} from '@expeditor/shared';
import { apiClient } from './client';

export const paymentsApi = {
  listForShipment(shipmentId: string): Promise<PaymentDto[]> {
    return apiClient
      .get<PaymentDto[]>(`/shipments/${shipmentId}/payments`)
      .then((r) => r.data);
  },
  listForOrder(orderId: string): Promise<PaymentDto[]> {
    return apiClient.get<PaymentDto[]>(`/orders/${orderId}/payments`).then((r) => r.data);
  },
  getOne(id: string): Promise<PaymentDto> {
    return apiClient.get<PaymentDto>(`/payments/${id}`).then((r) => r.data);
  },
  create(dto: PaymentCreateInput): Promise<PaymentDto> {
    return apiClient.post<PaymentDto>('/payments', dto).then((r) => r.data);
  },
  update(id: string, patch: PaymentPatchInput): Promise<PaymentDto> {
    return apiClient.patch<PaymentDto>(`/payments/${id}`, patch).then((r) => r.data);
  },
  remove(id: string): Promise<{ deleted: true }> {
    return apiClient.delete<{ deleted: true }>(`/payments/${id}`).then((r) => r.data);
  },
};
